import getMobileOperatingSystem from '@/utils/get-mobile-os'

export default () => {
  return getMobileOperatingSystem() === 'Android'
}
